import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { ApiInvService } from '../service/api-inv.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm:FormGroup;
  submitted=false;
  success=false;
  errorMsg: boolean=false;
  eMessage='';
  buttonDisabled:boolean=false;

  constructor(private formBuilder:FormBuilder,private Auth:AuthService,private router:Router,private apiInv:ApiInvService) {
    this.loginForm=this.formBuilder.group({
      username:['',Validators.required],
      password:['',Validators.required]
    })
   }

  ngOnInit() {
  }

  checkLogin(form){
    this.submitted=true;
    if(this.loginForm.invalid)
    {
      return false;
    }
    else
    {
     this.buttonDisabled=true;
     let isGst;
     this.Auth.checkUserAuth(form).subscribe(data=>{
      if(data.status)
      {
        localStorage.setItem('access_token',data.data.access_key);
        localStorage.setItem('auth_name',data.data.username);
        localStorage.setItem('user_role',data.data.role);
      //  this.router.navigate(['./admin']);
        this.router.navigateByUrl('/admin');
        this.buttonDisabled=false;
      }
      else
      {
        this.errorMsg=true;
        this.buttonDisabled=false;
        if(data.errors.password)
        {
          this.eMessage=data.errors.password;
        }
        else
        {
          this.eMessage=data.errors;
        }
       
      }

       
     },(error)=>{
       this.errorMsg=true;
       this.eMessage=error.error.message;
       this.buttonDisabled=false;
     });
    // return true;
    }

  }

}
